import React from 'react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

/**
 * Override the catalog page to inject the SyncButton next to the Create button.
 */
export const catalogSyncModule = catalogPlugin.withOverrides({
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        loader: async () => {
          const { CatalogPageWithSync } = await import(
            '../../components/catalog/CatalogPageWithSync'
          );
          return compatWrapper(
            React.createElement(CatalogPageWithSync),
          );
        },
      },
    }),
  ],
});
